module.exports = __webpack_public_path__ + "img/gengshifu-android.c25d5d04.png";